import axios from 'axios';
import apiConfig from '../config/apiConfig';

const API_BASE_URL = apiConfig.BASE_URL;

// Search articles (multilingual support)
export const searchArticles = async (query, params = {}) => {
  try {
    const { page = 1, limit = 10, category, author, lang, region } = params;
    const queryParams = new URLSearchParams();
    
    queryParams.append('q', query);
    if (page) queryParams.append('page', page);
    if (limit) queryParams.append('limit', limit);
    if (category) queryParams.append('category', category);
    if (author) queryParams.append('author', author);
    if (lang) queryParams.append('lang', lang);
    if (region) queryParams.append('region', region);
    
    const response = await axios.get(`${API_BASE_URL}/search?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error searching articles:', error);
    throw error;
  }
};

// Search categories (multilingual support)
export const searchCategories = async (query, params = {}) => {
  try {
    const { lang } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('q', query);
    if (lang) queryParams.append('lang', lang);
    
    const response = await axios.get(`${API_BASE_URL}/search/categories?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error searching categories:', error);
    throw error;
  }
};

// Search authors (multilingual support)
export const searchAuthors = async (query, params = {}) => {
  try {
    const { lang } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('q', query);
    if (lang) queryParams.append('lang', lang);
    
    const response = await axios.get(`${API_BASE_URL}/search/authors?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error searching authors:', error);
    throw error;
  }
};

// Global search (articles, categories, authors) - multilingual support
export const globalSearch = async (query, params = {}) => {
  try {
    const { lang, region } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('q', query);
    if (lang) queryParams.append('lang', lang);
    if (region) queryParams.append('region', region);
    
    const response = await axios.get(`${API_BASE_URL}/search/all?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error performing global search:', error);
    throw error;
  }
};


